
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.083 5.667c0-.88.713-1.584 1.584-1.584h2.375v1.584H7.667v2.375H6.083V5.667zm15.834 0v2.375h-1.584V5.667h-2.375V4.083h2.375a1.583 1.583 0 011.584 1.584zm-1.584 12.666v-2.375h1.584v2.375c0 .88-.713 1.584-1.584 1.584h-2.375v-1.584h2.375zm-14.25 0v-2.375h1.584v2.375h2.375v1.584H7.667a1.583 1.583 0 01-1.584-1.584zm6.334-14.25h3.166v1.584h-3.166V4.083zm0 14.25h3.166v1.584h-3.166v-1.584zm7.916-7.916h1.584v3.166h-1.584v-3.166zm-14.25 0h1.584v3.166H6.083v-3.166z"}}),_c('path',{attrs:{"fill":"#fff","d":"M17 15h6v6h-6z"}}),_c('path',{attrs:{"d":"M21.183 22.654a.412.412 0 01-.554-.196l-.908-1.975-1.046.842A.417.417 0 0118 21v-6.25a.417.417 0 01.683-.32l.005-.005 4.787 4.017a.417.417 0 01-.183.729l-1.317.258.917 1.971a.403.403 0 01-.2.55l-1.509.704z"}})])
          )
        }
      }
    